import { Component, input } from "@angular/core";
import { FloorplanSignalElement } from "@domain/project/floorplan/floorplan-signal-element";
import { FloorplanCustomPartNumbersComponent } from "@project/floorplanner/floorplan-custom-part-numbers/floorplan-custom-part-numbers.component";

@Component({
  selector: "app-floorplan-signal-element-detail-form",
  imports: [FloorplanCustomPartNumbersComponent],
  templateUrl: "./floorplan-signal-element-detail-form.component.html",
})
export class FloorplanSignalElementDetailFormComponent {
  readonly signalElement = input.required<FloorplanSignalElement>();
}
